module.exports = __webpack_public_path__ + "static/consulting-icon-25bf3adeaedec091241e4cac3556f36f.png";